import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

import { Link } from 'react-router-dom';

import ShopIcon from '@mui/icons-material/ShoppingCart';
import QuoteIcon from '@mui/icons-material/EditSquare';
import StatsIcon from '@mui/icons-material/AreaChart';
import AdminIcon from '@mui/icons-material/AdminPanelSettings';
import HomeIcon from '@mui/icons-material/Home';
import TransactionsIcon from '@mui/icons-material/ReceiptLong';
import { useAuth } from "./AuthProvider";

const SiteLinks = ({home, admin}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { user } = useAuth();
    return (
        <Box display="flex" flexDirection="column" justifyContent="flex-start" alignItems="flex-start" sx={{ m : "30px 40px 0 0"}}>
            {
                home ? 
                <IconButton component={Link} to="/" disableRipple>
                    <HomeIcon sx={{color: colors.gray[100], fontSize: 40}}/>
                    <Typography
                    variant="h6"
                    color={colors.gray[100]}
                    fontWeight="medium" 
                    sx={{m : "0 0 0 10px" }}
                    >
                    Hem
                    </Typography>
                </IconButton>
                : null
            }
            <IconButton component={Link} to="/baxshoppen" disableRipple>
                <ShopIcon sx={{color: colors.gray[100], fontSize: 40}}/>
                <Typography
                variant="h6"
                color={colors.gray[100]}
                fontWeight="medium" 
                sx={{m : "0 0 0 10px" }}
                >
                Baxshoppen
                </Typography>
            </IconButton>
            <IconButton component={Link} to="/citat" disableRipple>
                <QuoteIcon sx={{color: colors.gray[100], fontSize: 40}}/>
                <Typography
                variant="h6"
                color={colors.gray[100]}
                fontWeight="medium" 
                sx={{m : "0 0 0 10px" }}
                >
                Citat
                </Typography>
            </IconButton>
            <IconButton component={Link} to="/statistik" disableRipple>
                <StatsIcon sx={{color: colors.gray[100], fontSize: 40}}/>
                <Typography
                variant="h6"
                color={colors.gray[100]}
                fontWeight="medium" 
                sx={{m : "0 0 0 10px" }}
                >
                Statistik
                </Typography>
            </IconButton>
            {
            user !== null && user.admin ?
            <IconButton component={Link} to="/admin" disableRipple>
                <AdminIcon sx={{color: colors.gray[100], fontSize: 40}}/>
                <Typography
                variant="h6"
                color={colors.gray[100]}
                fontWeight="medium" 
                sx={{m : "0 0 0 10px" }}
                >
                Admin-panel
                </Typography>
            </IconButton>
            : null
            }
            <IconButton component={Link} to="/transactions" disableRipple>
                <TransactionsIcon sx={{color: colors.gray[100], fontSize: 40}}/>
                <Typography
                variant="h6"
                color={colors.gray[100]}
                fontWeight="medium" 
                sx={{m : "0 0 0 10px" }}
                >
                Transactions
                </Typography>
            </IconButton>
        </Box>
    )
}

export default SiteLinks